<template>
  <v-simple-table class="rounded-lg" :fixed-header="fixed_header" :height="height">
    <thead class="tableHeader text--secondary">
      <slot name="thead" />
    </thead>
    <draggable
      :value="value"
      @input="emit"
      @start="drag=true"
      @end="drag=false"
      tag="tbody"
      :draggable="!isXs?'.draggable':''"
    >
      <slot name="tbody" />
    </draggable>
    <tfoot>
      <slot name="footer"></slot>
    </tfoot>
  </v-simple-table>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: { Draggable },
  props: {
    height: {
      default: null,
    },
    fixed_header: {
      default: false,
    },
    value: {
      required: true,
    },
  },
  methods: {
    emit(value) {
      this.$emit("input", value);
    },
    getDraggableData() {
      return {
        on: { sort: this.emit },
      };
    },
  },
};
</script>

<style>
.v-data-table table tfoot
{
  position: sticky;
  bottom: 0;
  font-weight: bold;
}</style>